/*
 * @Author: 张天昊
 * @Date: 2024-05-25 15:23:27
 * @LastEditTime: 2024-06-28 15:19:32
 * @LastEditors: 张天昊
 * @Description: 在Panel内调用，用于确定卡片和卡片的锚定
 * @FilePath: /Mobile/src/pages/itineraryUniversal/composables/useAuxiliaryInfoCardScroll.js
 */
import { ref } from 'vue';
import { useTabsHeight } from './useTabsHeight';
import { triggerScroll } from '../utils';
import store from '@/store';
import { useNavBarHeight } from '@/composables/useNavBarHeight';

export function useAuxiliaryInfoCardScroll(type) {
  const cards = ref();
  const { getTabsNavHeight } = useTabsHeight();
  const { navBarHeight } = useNavBarHeight();

  const anchorTo = () => {
    if (
      store.state.itineraryUniversal.anchorTarget.type === type &&
      store.state.itineraryUniversal.anchorTarget.id
    ) {
      console.log(store.state.itineraryUniversal.anchorTarget);
      if (cards.value) {
        const targetComponent = cards.value.find(
          (comp) => comp.bid === store.state.itineraryUniversal.anchorTarget.id
        );
        if (targetComponent) {
          const el = targetComponent.$el;
          const offset = getTabsNavHeight() + parseInt(navBarHeight.value) + 15; // navheight + padding
          triggerScroll(el, -offset, () => {
            if (targetComponent.toggleHighlight) {
              targetComponent.toggleHighlight();
            }
          });
        }
      }
    }
  };

  return {
    cards,
    anchorTo
  };
}
